// extracted by mini-css-extract-plugin
export default {"document":"anketa_document__lQnLC","button":"anketa_button__OVbWK","submitButton":"anketa_submitButton__jJHuV","secondaryButton":"anketa_secondaryButton__HPZkX"};